<template>
  <span>
    <span v-if="$store.state.main.game.enableSuggestions && !$store.state.main.playerIsObserver">
      <b-toast
        id="send-successful-toast"
        no-close-button
        b-toaster-top-right
        variant="success"
        :solid="true"
      >
        <strong>
          {{ $t("sent") }}
        </strong>
      </b-toast>

      <b-toast
        id="send-error-toast"
        no-close-button
        b-toaster-top-right
        variant="danger"
        :solid="true"
      >
        <strong>
          {{ $t("error") }}
        </strong>
      </b-toast>

      <span v-if="!$store.state.main.playerIsObserver">
        <span v-if="!$store.state.main.suggestionBoxShow">
          <span class="button-float" @click="showBox()">    
            <font-awesome-icon size="2x" transform="down-7" icon="lightbulb"/>
          </span>
        </span>
        <span class="box-float" v-if="$store.state.main.suggestionBoxShow">
          <small><strong>{{
            $t("idea-or-suggestion")
          }}</strong></small>
          <base-input
            maxLength="500"
            id="input-suggestion"
            class="mb-3"
            v-model="suggestion"
            v-bind:placeholder="$t('idea')"
            v-on:keyup.native.enter="submit()"
            autocomplete="off"
          />
          <base-button
                  :disabled="suggestion.length === 0"
                  style="margin: 2px"
                  size="sm"
                  type="primary"
                  @click="submit()"
                  >{{ $t("send") }}
          </base-button>      
          <base-button
                  style="margin: 2px"
                  size="sm"
                  type="secondary"
                  @click="closeBox()"
                  >{{ $t("close") }}
          </base-button>      
        </span>
      </span>
    </span>
  </span>
</template>

<script>

import {
  sendSuggestion,
} from "../services/APIService";

export default {
  props: ["currentCaseNumber", "isClassicGame", "isRpsGame"], 
  data: function () {
    return {
    };
  },
  // TODO:
  // localizations
  created() {
  },
  computed: {
    suggestion: {
      get () {
        return this.$store.state.main.suggestionBoxSuggestion;
      },
      set (value) {
        this.$store.commit('setSuggestionBoxSuggestion', value)
      }
    }
  },
  methods: {
    showBox() {
      this.$store.commit('setSuggestionBoxShow', true);
    },
    closeBox() {
      this.$store.commit('setSuggestionBoxShow', false);
    },
    async submit() {
      if (this.$store.state.main.suggestionBoxSuggestion.length === 0) {
        return
      }
      let caseId = null;
      let rpsCaseId = null;
      if (this.currentCaseNumber) {
        if (this.isClassicGame) {
          caseId = (this.$store.getters.getCaseByCaseNumber(this.currentCaseNumber)).case;
        } else {
          rpsCaseId = (this.$store.getters.getRPSCaseByCaseNumber(this.currentCaseNumber)).rpsCase;
        }
      }

      try {
        await sendSuggestion(this.$store.state.main.game.id, this.$store.state.main.thisPlayerId, this.suggestion, caseId, rpsCaseId, this.$store.state.main.game.gameCode);

        this.$bvToast.show("send-successful-toast");      
        this.suggestion = "";
        this.closeBox();
      } catch (error) {
        this.$bvToast.show("send-error-toast");
      }
    }
  },
};
</script>


<style scoped>
/* https://codepen.io/androidcss/pen/yOopGp */

* {
  padding: 0;
  margin: 0;
}

body {
  font-family: Verdana, Geneva, sans-serif;
  font-size: 18px;
  background-color: #ccc;
}

.button-float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  left: 40px;
  background-color: #2dce89;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  z-index: 99999;
}
.box-float {
  position: fixed;
  width: 300px;
  padding: 3px;
  height: 125px;
  bottom: 40px;
  left: 40px;
  color: #000;
  background-color: #ffffff;
  border-radius: 3px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  z-index: 99999;
}
</style>

<i18n>
  {
    "en": {
      "sent": "Suggestion sent successfully",
      "error": "Error saving suggestion",
      "send-idea-or-suggestion": "Send teamwork development suggestion",
      "idea-or-suggestion": "Teamwork development suggestion",
      "idea": "suggestion",
      "send": "Send",
      "close": "Close"
    },
    "fi": {
      "sent": "Kehitysehdotus lähetetty",
      "error": "Lähetys epäonnistui",
      "send-idea-or-suggestion": "Tallenna tiimin toiminnan kehitysehdotus",
      "idea-or-suggestion": "Tiimin toiminnan kehitysehdotus",
      "idea": "kehitysehdotus",
      "send": "Lähetä",
      "close": "Sulje"
    },
    "sv": {
      "sent": "Utvecklingsförslagen har skickats",
      "error": "Fel i sändningen",
      "send-idea-or-suggestion": "Skicka förslag till utveckling av lagarbete",
      "idea-or-suggestion": "Utvecklingsförslag",
      "idea": "Utvecklingsförslag",
      "send": "Skicka",
      "close": "Stänga"
    },
    "de": {
      "sent": "Idee erfolgreich gesendet",
      "error": "Fehler beim Speichern der Idee",
      "send-idea-or-suggestion": "Idee oder Vorschlag senden (im Bericht gespeichert)",
      "idea-or-suggestion": "Idee oder Vorschlag",
      "idea": "idee",
      "send": "Schicken",
      "close": "Schließen"
    },
   "ko": {
    "sent": "아이디어가 성공적으로 전송되었습니다.",
      "error": "아이디어를 저장하는 중에 오류가 발생했습니다.",
      "send-idea-or-suggestion": "아이디어 또는 제안 보내기(보고서에 저장됨)",
      "idea-or-suggestion": "아이디어 또는 제안",
      "idea": "아이디어",
      "send": "보내다",
      "close": "닫다"
    }
  }
  </i18n>
